var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7.85L5.125 9.725C4.925 9.925 4.6875 10.0208 4.4125 10.0125C4.1375 10.0042 3.9 9.9 3.7 9.7C3.51667 9.5 3.42083 9.26667 3.4125 9C3.40417 8.73333 3.5 8.5 3.7 8.3L7.3 4.7C7.4 4.6 7.50833 4.52917 7.625 4.4875C7.74167 4.44583 7.86667 4.425 8 4.425C8.13333 4.425 8.25833 4.44583 8.375 4.4875C8.49167 4.52917 8.6 4.6 8.7 4.7L12.3 8.3C12.5 8.5 12.5958 8.73333 12.5875 9C12.5792 9.26667 12.4833 9.5 12.3 9.7C12.1 9.9 11.8625 10.0042 11.5875 10.0125C11.3125 10.0208 11.075 9.925 10.875 9.725L9 7.85V15C9 15.2833 8.90417 15.5208 8.7125 15.7125C8.52083 15.9042 8.28333 16 8 16C7.71667 16 7.47917 15.9042 7.2875 15.7125C7.09583 15.5208 7 15.2833 7 15V7.85ZM0 4V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H14C14.55 0 15.0208 0.195833 15.4125 0.5875C15.8042 0.979167 16 1.45 16 2V4C16 4.28333 15.9042 4.52083 15.7125 4.7125C15.5208 4.90417 15.2833 5 15 5C14.7167 5 14.4792 4.90417 14.2875 4.7125C14.0958 4.52083 14 4.28333 14 4V2H2V4C2 4.28333 1.90417 4.52083 1.7125 4.7125C1.52083 4.90417 1.28333 5 1 5C0.716667 5 0.479167 4.90417 0.2875 4.7125C0.0958333 4.52083 0 4.28333 0 4Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5bd1e7f8a1c9f759538da0d443bdd815.svg";
export { ForwardRef as ReactComponent };